'use client';

import { Icon } from '@petsmart-ui/sparky';
import { getBaseUrlJoined, trackMainNavLinkClick, trackNavigationHeaderClick } from '@libs/analytics';
import { clsx, usePageLayout } from '@libs/common-next';
import type { MouseEvent } from 'react';
import { handleServiceClick } from '@libs/experience-api';
import type { LegacyDrawerMenuItemProps } from './types';
import { getCategoryPath, trackCategoryPath } from '../MainMenu/utils';

export function LegacyDrawerMenuItem({
    category,
    categoryStack,
    handleCategoryClick,
    closeMenu,
}: LegacyDrawerMenuItemProps) {
    const { isAuthenticated } = usePageLayout();

    const depth = categoryStack.length - 1;
    const type = category.type !== 'image' ? category.type : 'text';
    const classes = clsx('category', `category--${type}`, depth > 0 && ['category--thin']);

    const categoryPath = categoryStack.slice(1).map(c => c.displayText || '');
    const newPath = getCategoryPath(categoryPath, category.displayText);
    const trackNewPath = trackCategoryPath(newPath);
    const webUrl = category.link ?? '#';

    function handleLinkClick(event: MouseEvent) {
        handleServiceClick({
            authType: isAuthenticated,
            event,
            link: category.link,
        });
        trackMainNavLinkClick(trackNewPath);
        trackNavigationHeaderClick(trackNewPath, getBaseUrlJoined(webUrl) ?? '', 'main nav');
        closeMenu();
    }

    return (
        <li className={classes}>
            {category.categories?.length && category.specialType !== 'Shop By Brand' ? (
                <button onClick={() => handleCategoryClick(category)} className="category__button" type="button">
                    <span>{category.displayText}</span>
                    <Icon name="chevron-right" />
                </button>
            ) : (
                <a
                    className={category.shopAllCategory ? 'category__link category__link--shop-all' : 'category__link'}
                    onClick={event => handleLinkClick(event)}
                    href={category.link ?? '#'}
                >
                    <span>{category.displayText}</span>
                </a>
            )}
        </li>
    );
}
